export default "__VITE_ASSET__Bd$un8VF__"